import {Directive, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[catFileDropZone]',
})
export class FileDropZoneDirective {
  @Output() fileDrop = new EventEmitter<FileList>();

  constructor() {
  }

  @HostListener('dragover', ['$event'])
  public onDragOver(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  @HostListener('drop', ['$event'])
  public onDrop(event) {
    event.stopPropagation();
    event.preventDefault();
    const eventData = event.dataTransfer;
    const droppedFiles = eventData.files;
    this.fileDrop.emit(droppedFiles);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-form/directives/file-drop-zone.directive.ts